/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#clearSearchResults__anchor
 */
export default () => {
  window.documentViewer.clearSearchResults();
};
